module.exports = __webpack_public_path__ + "static/img/YB-60V.3c307f19.png";